import {
  OnInit,
  Component,
  TemplateRef,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BoobleModalService } from 'booble-modal';
import { ChangeDetectorRef } from '@angular/core';

import { OrdersService } from 'src/app/shared/services/orders.service';
import { InboundOrderDto } from 'src/app/domain/models/dto/inbound-order.dto';

import { RegisterService } from 'src/app/shared/services/register.service';
import { NotifierService } from 'angular-notifier';
import { GenerateInvoiceModalComponent } from './inbound/components/modals/generate-invoice-modal/generate-invoice-modal.component';
import { NewOrderModalComponent } from './inbound/components/modals/new-order-modal/new-order-modal.component';
import { OrderDetailsModalComponent } from './shared/components/modals/order-details-modal/order-details-modal.component';
import { NewOrderModalOutboundComponent } from './outbound/components/modals/new-order-modal-outbound/new-order-modal-outbound.component';
import { CreateOrderComponent } from 'src/app/shared/modals/create-order/create-order.component';
import { AuthenticationService } from 'src/app/shared/services';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { GenericBottomSheetComponent } from 'src/app/shared/components/generic-bottom-sheet/generic-bottom-sheet.component';
import { ResponseTableModel } from 'src/app/domain/models/response-table.model';
import { TenantGeneralService } from 'src/app/core/tenant-general.service';
import { MerchantService } from 'src/app/core/merchant.service';

@Component({
  selector: 'app-inbound',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class OrdersComponent implements OnInit {
  tenant: string = '';
  rType: string = '';
  modal;
  tableDisplayedColumns: string[];
  tableDisplayColumns: string[];
  private readonly notifier: NotifierService;
  public orders: ResponseTableModel<InboundOrderDto[]>;
  showOrderError: boolean = false;
  haveOrders: boolean = false;
  showTables = false;
  isMobile: boolean;
  loading: boolean;
  pageSize: number = 10;
  pageNumber: number = 0;
  totalElements: number;
  warrenGlobalOnly: boolean = false;
  merchant: string = '';

  @ViewChild('bottomSheetContent') bottomSheetContent: TemplateRef<any>;

  get companyId() {
    return +this.accountService.getCompanyId();
  }

  get individualId() {
    return +this.accountService.getIndividualId();
  }

  constructor(
    private readonly modalService: BoobleModalService,
    private readonly route: ActivatedRoute,
    notifierService: NotifierService,
    private cdr: ChangeDetectorRef,
    private readonly router: Router,
    private readonly registerService: RegisterService,
    private readonly accountService: AuthenticationService,
    private readonly ordersService: OrdersService,
    private bottomSheet: MatBottomSheet,
    private tenantService: TenantGeneralService,
    private merchantService: MerchantService
  ) {
    this.notifier = notifierService;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  openBottomSheet() {
    this.bottomSheet.open(GenericBottomSheetComponent, {
      data: { content: this.bottomSheetContent },
    });
  }

  ngOnInit() {
    this.pageSize = +sessionStorage.getItem('orders-page-size') || 10;
    this.merchant = this.merchantService.getUserMerchant();

    this.route.paramMap.subscribe((params) => {
      const result = params.get('tenant');
      const rType = params.get('rType');

      if (result) this.tenant = params.get('tenant');
      if (rType) this.rType = params.get('rType');
    });

    this.route.queryParams.subscribe((params) => {
      if (params['openModal'] === 'true') {
        this.openOrderModal();

        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: { openModal: null },
          queryParamsHandling: 'merge',
          replaceUrl: true,
        });
      }
    });

    this.ordersService.listenerUpdate.subscribe(() => {
      this.initializeWithPagination(this.pageNumber, this.pageSize);
    });

    this.isMobile = window.innerWidth <= 820 ? true : false;

    this.warrenGlobalOnly =
      this.merchant == this.tenantService.WARREN_GLOBAL_NAME;
  }

  ngAfterViewInit() {
    this.cdr.detectChanges();
  }

  initializeWithPagination(page: number, pageSize: number) {
    this.loading = true;
    this.showTables = false;
    this.haveOrders = false;

    this.orders = null;
    this.ordersService
      .getClientWithPagination(this.rType, page + 1, pageSize)
      .subscribe({
        next: (result) => {
          this.loading = false;
          if (result.data.content.length > 0) {
            this.totalElements = result.data.totalElements;
            this.orders = result.data;
            this.haveOrders = true;
            this.showTables = true;
          }
        },
        error: () => {
          this.loading = false;
          this.showOrderError = true;
          this.haveOrders = false;
          this.showTables = false;
        },
      });
  }

  updatePageData({
    pageNumber,
    pageSize,
  }: {
    pageNumber: number;
    pageSize: number;
  }) {
    this.initializeWithPagination(pageNumber, pageSize);

    this.pageNumber = pageNumber;
    this.pageSize = pageSize;
  }

  openTermsModal() {
    this.modalService.present(GenerateInvoiceModalComponent);
  }

  reloadPage() {
    window.location.reload();
  }

  openNewOrderModal() {
    this.registerService.getRegisterStep().subscribe({
      next: (stepResult) => {
        if (stepResult.data.registerStep.id >= 2) {
          if (this.rType == '0') {
            this.modal = this.modalService.present(NewOrderModalComponent);
          } else {
            this.modal = this.modalService.present(
              NewOrderModalOutboundComponent
            );
          }
        } else {
          this.notifier.notify(
            'error',
            'Atualize o cadastro com seus dados bancários !'
          );
        }
      },
      error: (err) => {},
    });
  }

  openOrderModal() {
    if (!this.isMobile) {
      this.modalService.present(CreateOrderComponent, this.rType);
    } else {
      this.openBottomSheet();
    }
  }

  openOrderDetailsModal() {
    this.modalService.present(OrderDetailsModalComponent);
  }
}
